export default "__VITE_ASSET__e26e8616__"